// src/components/data/cuestionariosStore.js
// Store demo de cuestionarios, cada uno con 3 preguntas y 4 respuestas

const STORAGE_KEY = "lms_demo_cuestionarios";

function buildDemoPreguntas(nombreTema) {
  return [
    {
      id: 1,
      texto: `En relación con "${nombreTema}", ¿qué acción es la MÁS adecuada en caso de duda?`,
      respuestas: [
        {
          id: 1,
          texto: "Ignorar la situación y seguir trabajando normalmente.",
          correcta: false,
        },
        {
          id: 2,
          texto: "Consultar las políticas internas o al área responsable.",
          correcta: true,
        },
        {
          id: 3,
          texto: "Compartir la duda en redes sociales para ver qué opinan.",
          correcta: false,
        },
        {
          id: 4,
          texto: "Actuar según criterio personal sin informar a nadie.",
          correcta: false,
        },
      ],
    },
    {
      id: 2,
      texto: `Sobre "${nombreTema}", ¿cuál de las siguientes opciones describe MEJOR una buena práctica?`,
      respuestas: [
        {
          id: 1,
          texto: "Evitar documentar decisiones para reducir carga administrativa.",
          correcta: false,
        },
        {
          id: 2,
          texto: "Registrar y conservar la evidencia necesaria de forma ordenada.",
          correcta: true,
        },
        {
          id: 3,
          texto: "Compartir credenciales con el equipo para agilizar procesos.",
          correcta: false,
        },
        {
          id: 4,
          texto: "Responder únicamente cuando la autoridad lo solicite.",
          correcta: false,
        },
      ],
    },
    {
      id: 3,
      texto: `Pensando en "${nombreTema}", ¿qué opción representa un riesgo importante si NO se atiende?`,
      respuestas: [
        {
          id: 1,
          texto: "Mantener actualizados los controles y registros internos.",
          correcta: false,
        },
        {
          id: 2,
          texto: "Desconocer las políticas de la organización y no pedir apoyo.",
          correcta: true,
        },
        {
          id: 3,
          texto: "Participar en cursos de actualización periódicamente.",
          correcta: false,
        },
        {
          id: 4,
          texto: "Informar incidencias a los canales oficiales.",
          correcta: false,
        },
      ],
    },
  ];
}

const DEMO_CUESTIONARIOS = [
  {
    id: 1,
    tipo: "NORMATIVO",
    nombre: "Ciberseguridad",
    version: 2025,
    fechaCreacion: "10/1/2025 10:19:41 AM",
    preguntas: buildDemoPreguntas("Ciberseguridad"),
  },
  {
    id: 2,
    tipo: "NORMATIVO",
    nombre: "Código de Conducta en el Mercado de Valores (CCMV)",
    version: 2025,
    fechaCreacion: "9/22/2025 9:56:39 AM",
    preguntas: buildDemoPreguntas("Código de Conducta en el Mercado de Valores"),
  },
  {
    id: 3,
    tipo: "NORMATIVO",
    nombre: "Cultura de Riesgos",
    version: 2025,
    fechaCreacion: "9/26/2025 10:43:10 AM",
    preguntas: buildDemoPreguntas("Cultura de Riesgos"),
  },
  {
    id: 4,
    tipo: "NORMATIVO",
    nombre: "FATCA & CRS",
    version: 2025,
    fechaCreacion: "9/22/2025 1:09:46 PM",
    preguntas: buildDemoPreguntas("FATCA & CRS"),
  },
  {
    id: 5,
    tipo: "NORMATIVO",
    nombre: "FX GLOBAL CODE",
    version: 2025,
    fechaCreacion: "9/22/2025 1:30:24 PM",
    preguntas: buildDemoPreguntas("FX GLOBAL CODE"),
  },
  {
    id: 6,
    tipo: "NORMATIVO",
    nombre: "Manual de Conducta (Código de ética)",
    version: 2025,
    fechaCreacion: "9/22/2025 11:34:57 AM",
    preguntas: buildDemoPreguntas("Manual de Conducta (Código de ética)"),
  },
  {
    id: 7,
    tipo: "NORMATIVO",
    nombre: "Partes Relacionadas",
    version: 2025,
    fechaCreacion: "9/22/2025 1:57:55 PM",
    preguntas: buildDemoPreguntas("Partes Relacionadas"),
  },
  {
    id: 8,
    tipo: "NORMATIVO",
    nombre: "Plan de Continuidad de Negocio",
    version: 2025,
    fechaCreacion: "10/28/2025 7:31:04 PM",
    preguntas: buildDemoPreguntas("Plan de Continuidad de Negocio"),
  },
  {
    id: 9,
    tipo: "NORMATIVO",
    nombre: "PLD CFT",
    version: 2025,
    fechaCreacion: "10/1/2025 4:45:53 PM",
    preguntas: buildDemoPreguntas("PLD CFT"),
  },
  {
    id: 10,
    tipo: "NORMATIVO",
    nombre: "Prácticas de Venta",
    version: 2025,
    fechaCreacion: "10/1/2025 1:25:26 PM",
    preguntas: buildDemoPreguntas("Prácticas de Venta"),
  },
];

function canUseStorage() {
  return typeof window !== "undefined" && !!window.localStorage;
}

function loadCuestionarios() {
  if (!canUseStorage()) return DEMO_CUESTIONARIOS;
  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) return DEMO_CUESTIONARIOS;
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed) || parsed.length === 0) {
      return DEMO_CUESTIONARIOS;
    }
    return parsed;
  } catch {
    return DEMO_CUESTIONARIOS;
  }
}

function saveCuestionarios(lista) {
  if (!canUseStorage()) return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(lista));
}

// --- API Pública ---

export function listCuestionarios() {
  return loadCuestionarios();
}

export function getCuestionarioById(id) {
  return loadCuestionarios().find((c) => c.id === Number(id)) || null;
}

export function getPreguntasByCuestionario(id) {
  const q = getCuestionarioById(id);
  return q?.preguntas || [];
}

export function updatePreguntas(cuestionarioId, preguntas) {
  const lista = loadCuestionarios();
  const updated = lista.map((c) =>
    c.id === Number(cuestionarioId) ? { ...c, preguntas: [...preguntas] } : c
  );
  saveCuestionarios(updated);
  return getPreguntasByCuestionario(cuestionarioId);
}
